import * as MD from '@material-ui/core';
import { SvgIcon } from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { IApplicationState, IConnectedReduxProps } from '../Store';
import { ILayoutState } from '../Store/Layout/Types';
import { getTheme } from '../Themes';
import { YacastLogoIcon } from '../Themes/svg/yacast-logo';

interface IPropsFromState {
	layout: ILayoutState;
	ui: any;
	updateUI: (name: string, value: any) => void;
}

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

getTheme();

const styles = (theme: any) =>
	MD.createStyles({
		container: {
			height: '100%',
		},
		content: {
			'&.noDrawer': {
				paddingLeft: theme.spacing(3),
			},
			flexGrow: 1,
			minHeight: `calc(100% - ${theme.UserManagement.dimensions.appBarHeight}px)`,
			overflow: 'hidden',
			padding: theme.spacing(3),
			paddingLeft:
				theme.UserManagement.dimensions.drawerWidth + theme.spacing(3),
			paddingTop: theme.UserManagement.dimensions.appBarHeight,
			transition: 'padding-left 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
		},
		toolbar: theme.mixins.toolbar,
		listGridContainer: {
			margin: '15px',
		},
		listItemContainer: {
			border: '1px solid #cccccc',
			padding: '5px',
			borderRadius: '5px',
		},
		button: {
			margin: theme.spacing(1),
			marginLeft: 0,
			marginRight: 0,
			textTransform: 'uppercase',
		},
		card: {
			maxWidth: '40%',
			minWidth: '20%',
			marginTop: '50px',
		},
		cardContent: {
			width: '100%',
		},
		errorContainer: {
			width: '100%',
			justifyContent: 'center',
			textAlign: 'center',
			color: 'red',
		},
		form: {
			display: 'flex',
			flexDirection: 'column',
			flexWrap: 'wrap',
		},
		media: {
			height: 140,
		},
	});

interface IState {
	isDisconnected: boolean;
}

export class LayoutPasswordComponent extends React.Component<AllProps, IState> {
	public constructor(props: AllProps) {
		super(props);
		this.state = {
			isDisconnected: false,
		};
	}

	public componentDidMount() {
		document.body.style.overflowX = 'hidden';
		this.handleConnectionChange();
		window.addEventListener('online', this.handleConnectionChange);
		window.addEventListener('offline', this.handleConnectionChange);
	}

	componentWillUnmount() {
		window.removeEventListener('online', this.handleConnectionChange);
		window.removeEventListener('offline', this.handleConnectionChange);
	}

	handleConnectionChange = () => {
		const condition = navigator.onLine ? 'online' : 'offline';
		if (condition === 'online') {
			if (this.state.isDisconnected) {
				return this.setState({ isDisconnected: false });
			}
			return;
		}
		if (!this.state.isDisconnected) {
			return this.setState({ isDisconnected: true });
		}
	};

	private showNoticeIfDisconnected = () => {
		if (this.state.isDisconnected) {
			return (
				<div
					style={{
						background: 'red',
						zIndex: 10000,
						position: 'absolute',
						width: '100%',
						textAlign: 'center',
						opacity: '0.5',
					}}
				>
					Pas de réseaux
				</div>
			);
		}
	};
	public render(): React.ReactNode {
		const { classes, layout } = this.props;
		const theme = getTheme(layout.theme);
		return (
			<MD.Card className={classes.card}>
				{this.showNoticeIfDisconnected()}
				<MD.CardActionArea></MD.CardActionArea>
				<MD.CardActions>
					<MD.CardContent className={classes.cardContent}>
						<MD.Typography
							gutterBottom={true}
							variant="h4"
							component="h2"
						>
							<SvgIcon
								component={YacastLogoIcon}
								htmlColor={theme.palette.text.primary}
							/>
						</MD.Typography>

						<MD.Typography
							variant="caption"
							color="textSecondary"
							component="p"
						></MD.Typography>
						{this.props.layout.pageContent}
					</MD.CardContent>
				</MD.CardActions>
			</MD.Card>
		);
	}
}

const mapStateToProps = ({ layout }: IApplicationState) => ({
	layout,
});

export const LayoutPassword = connect(mapStateToProps)(
	MD.withStyles(styles)(LayoutPasswordComponent)
);
